<template>
  <div class="control-value">
    <textarea-editor
      v-if="['text', 'rich', 'url'].includes(control._type)"
      :var-group="filteredGroupList"
      :placeholder="control.hint"
      :value="localValue"
      @input="emitVal"
    ></textarea-editor>
    <div v-else class="main">
      <div v-if="showVar" class="var-container">
        <span class="var">{{ value[0].label }}</span>
        <div class="icon-close" @click="emitVal()">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div v-else class="main-value">
        <normal-select
          v-if="control._type === 'option'"
          :selected-item="localValue"
          size="normal"
          @update:selectedItem="emitVal"
          :multiple="!control.oneFlag"
          :placeholder="control.hint"
          :select-list="optionSelectList"
        ></normal-select>
        <address-selector
          v-else-if="control._type === 'area'"
          :value="localValue"
          @input="emitVal"
          :level="control.level"
          :placeholder="control.hint"
          :checkStrictly="!control.lastLevelOnly"
          :multiple="!control.oneFlag"
        ></address-selector>
        <el-date-picker
          v-else-if="control._type === 'time'"
          :value="localValue"
          @input="emitVal"
          :placeholder="control.hint"
          :type="dateTimePicker.type"
          :value-format="dateTimePicker.valueFormat"
          :format="dateTimePicker.displayFormat"
          :picker-options="dateTimePicker.pickerOptions"
        ></el-date-picker>

        <template v-else-if="control._type === 'location'">
          <div class="location-container pointer" @click="$refs.locationDialog.open()">
            <div v-if="!localValue" class="empty">
              <input
                style="z-index:0"
                class="el-input__inner pointer"
                type="text"
                autocomplete="off"
                placeholder="请选择"
                disabled
              />
              <i class="el-icon-location"></i>
            </div>
            <div v-else class="address-card">
              <div v-if="localValue.poiName" class="title">{{ localValue.poiName }}</div>
              <div class="detail" v-tip>{{ localValue.address }}</div>
              <span class="icon-delete" @click.stop="emitVal(null)">
                <svg-icon icon-class="svgo_close-round"></svg-icon>
              </span>
            </div>
          </div>
          <location-dialog
            ref="locationDialog"
            :key="control._cid"
            :value="localValue"
            @input="emitVal"
          ></location-dialog>
        </template>
        <div v-else-if="control._type === 'ref'" class="empty">
          <input
            class="el-input__inner pointer"
            type="text"
            autocomplete="off"
            placeholder="请点击右侧按钮选择变量"
            disabled
          />
        </div>
        <upload-file
          v-else-if="control._type === 'file'"
          ref="upload-file"
          :oneFlag="true"
          @updateFiles="emitVal"
        ></upload-file>
        <el-checkbox
          v-else-if="control._type === 'check'"
          :value="localValue"
          @input="emitVal"
          class="special"
        ></el-checkbox>
        <rate
          v-else-if="control._type === 'rate'"
          :value="localValue"
          @output="emitVal"
          class="special"
          :control="control"
        ></rate>
        <user-selector
          v-else-if="control._type === 'staff'"
          :multiple="!control.oneFlag"
          :value="localValue"
          @change="emitVal"
        ></user-selector>
        <department-selector
          v-else-if="control._type === 'department'"
          :value="localValue"
          @change="emitVal"
          :multiple="!control.oneFlag"
        ></department-selector>
        <company-selector
          v-else-if="control._type === 'company'"
          :value="localValue"
          @change="emitVal"
          :scope="control.scope"
          :multiple="!control.oneFlag"
        ></company-selector>
        <el-input
          v-else-if="control._dataType === 'number'"
          type="number"
          :value="localValue"
          :placeholder="control.hint"
          @input="emitVal"
          :precision="control.decimal"
        ></el-input>
        <input
          v-else
          class="el-input__inner pointer"
          type="text"
          autocomplete="off"
          placeholder="暂不支持"
          disabled
        />
      </div>
      <el-tooltip effect="dark" content="使用本流程节点对象的值" placement="top">
        <group-dropdown-menu :group-list="filteredGroupList" @select="selectVar">
          <div class="btn-add buttonSelectTrigger">
            <i class="el-icon-plus"></i>
          </div>
        </group-dropdown-menu>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import TextareaEditor from "@/components/UIComponents/TextareaEditor"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import GroupDropdownMenu from "@/components/UIComponents/GroupDropdownMenu/GroupDropdownMenu"
import AddressSelector from "@/components/AddressSelector"
import LocationDialog from "@/components/UIComponents/LocationDialog"
import UserSelector from "@/components/FormControl/UserSelector"
import DepartmentSelector from "@/components/FormControl/DepartmentSelector"
import CompanySelector from "@/components/FormControl/CompanySelector"
import Rate from "@/components/BaseComponents/Rate"
import { timeTypeList } from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"
import dj from "dayjs"
import { filterTreeVarGroup } from "@/utils/workFlow"
import { arrayValueTypes } from "@/utils/sheet"
import UploadFile from "@/components/Sheet/SheetForm/FormItem/UploadFile"
import { isValidObjectId } from "@/utils/common"
export default {
  name: "control-value",
  components: {
    UploadFile,
    NormalSelect,
    TextareaEditor,
    GroupDropdownMenu,
    AddressSelector,
    LocationDialog,
    UserSelector,
    DepartmentSelector,
    CompanySelector,
    Rate
  },
  props: {
    value: [
      Array, // {label:'',value:'',var:boolean}
      Object // textarea {"text":"'12212'","arr":[{"type":"text","text":"12212"}]}
    ],
    control: {
      type: Object,
      required: true
    },
    groupList: Array
  },
  computed: {
    localValue() {
      if (["text", "rich", "url"].includes(this.control._type)) {
        return this.value
      }
      let vals = (this.value || []).filter(valItem => !valItem.var).map(valItem => valItem.value)
      switch (this.control._type) {
        case "option":
          return this.control.oneFlag ? vals[0] : vals
        case "location":
        case "time":
        case "rate":
        case "money":
        case "number":
        case "progress":
        case "check":
          return vals[0]
        case "area":
          vals = vals.map(val => val.split("-"))
          return this.control.oneFlag ? vals[0] : vals
        case "staff":
        case "department":
        case "company":
          return vals
        default:
          return this.value
      }
    },
    dateTimePicker() {
      if (this.control._type != "time") return null
      const timeTypeMap = this._.keyBy(timeTypeList, "value")
      let timeTypeItem = timeTypeMap[this.control.timeType]
      const isSameOrBefore = require("dayjs/plugin/isSameOrBefore")
      const isSameOrAfter = require("dayjs/plugin/isSameOrAfter")
      dj.extend(isSameOrBefore)
      dj.extend(isSameOrAfter)
      return {
        type: timeTypeItem.controlType,
        valueFormat: timeTypeItem.displayFormat, // value的格式
        djFormat: timeTypeItem.djFormat, // dayjs的格式
        displayFormat: timeTypeItem.displayFormat, // 日期输入框实际展示的格式
        pickerOptions: {
          selectableRange: this.control.timeScope.timeRange?.join(" - "),
          format: timeTypeItem.timeFormat, // 当控件选择时间时,时间的格式
          disabledDate: date => {
            if (
              !this._.isNumber(this.control.timeScope.weekLimit) &&
              !this._.isArray(this.control.timeScope.dateRange)
            )
              return false
            return (
              !(
                this.control.timeScope.dateRange &&
                (this.control.timeScope.dateRange.includes("Now")
                  ? this.control.timeScope.dateRange[0] == null
                    ? dj(date).isSameOrBefore(new Date(), "date")
                    : dj(date).isSameOrAfter(new Date(), "date")
                  : dj(date).isSameOrAfter(new Date(this.control.timeScope.dateRange[0]), "date") &&
                    dj(date).isSameOrBefore(new Date(this.control.timeScope.dateRange[1]), "date"))
              ) || !(this.control.timeScope.weekLimit & (1 << this.getISOWeekOfDate(date)))
            )
          }
        }
      }
    },
    showVar() {
      return !this._.isEmpty(this.value) && this.value[0]?.var
    },
    optionSelectList() {
      if (this.control._type != "option") return []
      return this.control.options
    },
    filteredGroupList() {
      return filterTreeVarGroup({
        varGroup: this.groupList,
        filterFunc: ({ strValue, control }) => {
          if (["text", "rich", "url"].includes(this.control._type)) return strValue
          if (["string", "number"].includes(this.control._dataType))
            return control._dataType === this.control._dataType
          switch (this.control._type) {
            case "option":
              return (
                control._cid === this.control._cid ||
                (control.optionType === "选项集" && control.setId === this.control.setId) ||
                (control._type === "text" && control.array) ||
                (control._type === "option" && control._cid.length != 24) // 代码块变量
              )
            case "time":
            case "staff":
            case "department":
            case "company":
            case "area":
            case "file":
            case "location":
              return control._type === this.control._type
            case "ref":
              return (
                control._type === this.control._type &&
                (control.refSheetId === this.control.refSheetId || !control.refSheetId) // refSheetId为空:代码块输出变量
              )
          }
          return false
        },
        mapFunc: option => {
          switch (this.control._type) {
            case "text":
            case "rich":
            case "url":
              return Object.assign({}, option, { value: option.strValue })
            default:
              return option
          }
        }
      })
    }
  },
  data() {
    return {}
  },
  mounted() {
    if (this.control._type === "file" && this.localValue && isValidObjectId(this.localValue[0].id))
      this.$nextTick(() => this.$refs["upload-file"].init(this.localValue))
  },
  methods: {
    emitVal(val) {
      switch (this.control._type) {
        case "rich":
        case "text":
        case "url":
          this.$emit("input-val", val?.text)
          this.$emit("input", val)
          break
        case "option": {
          let vals = this.control.oneFlag ? (val ? [val] : []) : val || []
          this.$emit("input-val", vals)
          this.$emit(
            "input",
            vals.map(val => ({ label: val, value: val, var: false }))
          )
          break
        }
        case "time":
        case "rate":
        case "money":
        case "number":
        case "progress":
        case "check":
          this.$emit("input-val", val)
          this.$emit("input", [{ label: val, value: val, var: false }])
          break
        case "area": {
          let vals = this.control.oneFlag ? (val ? [val] : []) : val || []
          vals = vals.map(val => val.join("-"))
          this.$emit("input-val", vals)
          this.$emit(
            "input",
            vals.map(val => ({ label: val, value: val, var: false }))
          )
          break
        }
        case "location":
          this.$emit("input-val", val)
          this.$emit("input", [{ label: null, value: val, var: false }])
          break
        case "staff":
        case "department":
        case "company": {
          let vals = val || []
          this.$emit(
            "input-val",
            vals.map(v => v.id)
          )
          this.$emit(
            "input",
            vals.map(v => ({ label: v.name, value: v.id, var: false }))
          )
          break
        }
        case "file":
          this.$emit("input-val", val)
          this.$emit("input", val)
          break
        default:
          this.$emit("input-val", val)
          this.$emit("input", val)
      }
    },
    selectVar({ label, value }) {
      this.$emit("input", [{ label, value, var: true }])
      if (arrayValueTypes.includes(this.control._type)) {
        this.$emit("input-val", [value])
      } else {
        this.$emit("input-val", value)
      }
    },
    getISOWeekOfDate(date) {
      // 周一:0 周二:1 ... 周日:6
      return (dj(date).day() - 1 + 7) % 7
    }
  }
}
</script>

<style lang="scss" scoped>
.control-value {
  .textarea-container {
    margin-top: 0;
  }
  .main {
    display: flex;
    ::v-deep {
      .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .var-container {
      flex: 1;
      display: flex;
      align-items: center;
      height: 40px;
      line-height: 28px;
      position: relative;
      padding: 0 10px;
      background: #f8f8f8;
      border: 1px solid #ccc;
      border-radius: 4px 0 0 4px;
      box-sizing: border-box;
      &:hover {
        border-color: #2196f3;
      }
      .var {
        padding: 1px 4px;
        font-size: 14px;
        border-radius: 14px;
        //border: 1px solid #9cd7f1;
      }
      .icon-close {
        margin-left: auto;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: #1e88e5;
        }
      }
    }
    .main-value {
      flex: 1;
      .address-selector,
      .el-date-editor {
        width: 100%;
      }
      .special {
        display: flex;
        align-items: center;
        padding-left: 16px;
        box-sizing: border-box;
        height: 100%;
        border: 1px solid #dcdfe6;
        border-radius: 4px 0 0 4px;
      }
      .upload-file {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        height: 38px;
        ::v-deep {
          .upload-button {
            top: 2px;
          }
          .upload-container {
            height: 100%;
            .base-upload {
              height: 100%;
              .el-upload {
                height: 100%;
                .row {
                  height: 100%;
                  .content {
                    padding: 0;
                  }
                }
              }
            }
          }
        }
      }
      .user-selector,
      .department-selector,
      .company-selector {
        ::v-deep {
          .user-scope-selector-container {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            .value-wrapper {
              min-height: 38px;
            }
          }
        }
      }
      .location-container {
        border-radius: 4px 0 0 4px;
        min-height: 30px;
        border: 1px solid #dcdfe6;
        overflow: hidden;
        position: relative;
        &:hover {
          border: 1px solid #c0c4cc;
        }
        &.disabled {
          &:hover {
            border: 1px solid #dcdfe6;
          }
          .empty,
          .address-card {
            background: #f5f7fa;
          }
          .el-input__inner {
            z-index: 0 !important;
          }
        }
        .empty {
          display: flex;
          align-items: center;
          padding: 0 9px 0 15px;
          position: relative;
          height: 38px;
          .el-input__inner {
            border: none;
            line-height: unset;
            height: unset;
            background: unset;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
          }
          .el-icon-location {
            margin-left: auto;
            color: #c0c4cc;
          }
        }
        .address-card {
          padding: 5px 15px;
          line-height: 22px;
          color: #606266;
          border: none;
          ::v-deep .el-card__body {
            padding: 5px;
          }
          .title {
            font-size: 14px;
            font-weight: bold;
          }
          .detail {
            font-size: 12px;
          }
          &:hover {
            .icon-delete {
              visibility: visible;
            }
          }
          .icon-delete {
            visibility: hidden;
            position: absolute;
            padding: 4px;
            right: 0;
            top: 0;
            cursor: pointer;
            font-size: 18px;
            color: #bdbdbd;
            &:hover {
              color: #1e88e5;
            }
          }
        }
      }
    }
    .btn-add {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-width: 1px 1px 1px 0;
      border-style: solid;
      box-sizing: border-box;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-color: #ddd;
      font-size: 20px;
      color: #9e9e9e;
      cursor: pointer;
      &:hover {
        color: #1e88e5;
      }
    }
  }
}
</style>
